import { mapGetters, mapMutations /*mapState*/ } from 'vuex';
import KnGeneralSummary from '../../components/KnGeneralSummary/KnGeneralSummary.vue';
export default {
  name: 'TeacherDashboardIndex',
  components: { KnGeneralSummary },
  mixins: [],
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['nameUserLoggedIn']),
  },
  created() {
    this.setIsLogin(false);
  },
  methods: {
    ...mapMutations(['setIsLogin']),
  },
};
